import { css } from 'styled-system/css';
import { AccessSignupForm } from './AccessSignupForm';
import { Container } from './Container';
import { Reveal } from './Reveal';

export function CtaSection() {
  return (
    <section
      id="get-access"
      aria-label="Get early access"
      className={css({
        paddingBlock: { base: '20', md: '28' },
        scrollMarginTop: '20',
      })}
    >
      <Container>
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '3xl',
            marginInline: 'auto',
            paddingBlock: { base: '16', md: '24' },
            paddingInline: { base: '6', md: '8' },
            border: '1px solid',
            borderColor: 'border.hairline',
            background: 'bg.sunken',
          })}
        >
          <Reveal>
            <span
              className={css({
                textStyle: 'eyebrow',
                color: 'text.muted',
              })}
            >
              Early access
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h2
              className={css({
                textStyle: 'display',
                fontSize: { base: '3xl', md: '5xl' },
                color: 'text.primary',
                marginTop: '4',
              })}
            >
              Welcome to the future
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p
              className={css({
                fontSize: { base: 'base', md: 'md' },
                color: 'text.secondary',
                lineHeight: 'relaxed',
                textWrap: 'pretty',
                maxWidth: '40ch',
                marginTop: '6',
              })}
            >
              Get early access before we open to everyone. Join the waitlist.
            </p>
          </Reveal>
          <Reveal
            delay={240}
            className={css({
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            })}
          >
            <AccessSignupForm
              idPrefix="cta"
              className={css({
                marginTop: '10',
              })}
            />
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
